import Lottie from 'lottie-react';
import classNames from 'classnames';
import processingPaymentPayOnReg from '../../../../../animations/post-payment_v1.json';
import processingPayment from '../../../../../animations/processing-payment.json';
import './ProcessingPayment.scss';

export default function ProcessingPayment({ isPayOnReg = false }) {
  return (
    <div
      className={classNames('ProcessingPayment', {
        'ProcessingPayment--payonreg': isPayOnReg,
      })}
    >
      <Lottie
        animationData={isPayOnReg ? processingPaymentPayOnReg : processingPayment}
        loop
        autoplay
        style={{ aspectRatio: '1', height: '100%' }}
      />
    </div>
  );
}
